import { useEffect } from "react";
import * as Sentry from "@sentry/react";

import { ErrorBoundary } from "./utils/boundary/ErrorBoundary";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";

import AppLocale from "./languages";

import Router from "./router/Router";
import { useCustomise } from "./context/customiseContext";

import { leedpulseTheme } from "./configs/theme/themePresets";

// Moment
import moment from 'moment/min/moment-with-locales';

export default function App() {
  // Context
  const {language, direction} = useCustomise();

  // Lang
  const currentAppLocale =
    AppLocale[localStorage.getItem("lp-lang") || language];

  useEffect(() => {
    document
      .querySelector("html")
      .setAttribute(
        "lang",
        localStorage.getItem("lp-lang") || language,
      );

      moment.locale(localStorage.getItem("lp-lang") || language);
  }, [language]);

  return (
    <ErrorBoundary onError={(error) => Sentry.captureException(error)}>
      <ConfigProvider
        theme={leedpulseTheme}
        renderEmpty={() => "Aucun résultat"}
        locale={currentAppLocale.antd}
        direction={direction}
      >
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <Router />
        </IntlProvider>
      </ConfigProvider>
    </ErrorBoundary>
  );
}
